<template>
  <div v-if="summary" class="inherit-link-styling">
    <div v-html="split ? htmlText.split('><')[0] : ''"></div>
    <a
      tabindex="0"
      @click="summary = false"
      @keyup.enter="summary = false"
      style="position: relative; top: -15px"
    >
      Læs mere
    </a>
  </div>
  <div v-else class="inherit-link-styling">
    <div v-html="htmlText"></div>
    <a
      tabindex="0"
      @click="summary = true"
      @keyup.enter="summary = true"
      style="position: relative; top: -15px"
    >
      Læs mindre
    </a>
  </div>
</template>

<script>
export default {
  props: {
    split: {
      type: Boolean,
      default: true,
    },
    htmlText: {
      type: String,
      default: "<p>Tekst.</p><p>Foldet ud.</p>",
    },
  },
  data() {
    return {
      summary: true,
    };
  },
};
</script>

<style></style>
